/* eslint-disable indent */
import { logError } from '@log';
import { request } from './request';
import {
  // MOCK_LOGIN_RESP,
  // MOCK_GET_RA_REASON,
  // MOCK_RA_ITEMS,
} from './mock';

const loginApi = 'query-related-claims';

/**
 * 校验登陆是否需要跳转4.0还是2.0系统
 * @param {String} email 邮箱地址
 * @param {String} orderNumber 订单id
 */
export const getSvTrackRouter = async (email, orderNumber) => {
  try {
    if (!email || !orderNumber) {
      logError(new Error(`Empty email or orderNumber, email=${email}, orderNumber=${orderNumber}`));
      return null;
    }
    const resp = await request('sv_router', {
      body: {
        email,
        orderNumber,
      },
      path: '/controller/resolutioncenter/orderservice/',
    });
    // console.log('query-related-claims 入参(登录)', { email, orderNumber });
    // const resp = MOCK_LOGIN_RESP(orderNumber);
    if (!resp) {
      logError(new Error(`${loginApi} no resp`));
      return null;
    }
    return resp;
  } catch (error) {
    logError(error);
    return null;
  }
};

/**
 * 登陆
 * @param {String} email 邮箱地址
 * @param {String} orderNumber 订单id
 */
export const estimateClaim = async (email, orderNumber) => {
  try {
    if (!email || !orderNumber) {
      logError(new Error(`Empty email or orderNumber, email=${email}, orderNumber=${orderNumber}`));
      return null;
    }
    const resp = await request(loginApi, {
      body: {
        email,
        orderNumber,
        policyType: '17BP',
      },
    });
    // console.log('query-related-claims 入参(登录)', { email, orderNumber });
    // const resp = MOCK_LOGIN_RESP(orderNumber);
    if (!resp) {
      logError(new Error(`${loginApi} no resp`));
      return null;
    }
    return resp;
  } catch (error) {
    logError(error);
    return null;
  }
};

/**
 * 根据保单获取包裹数据
//  * @param {String} email 邮箱地址
//  * @param {String} policyId 保单 id
 */
// export const getPackage = async (email, policyId) => {
//   try {
//     if (!email || !policyId) {
//       logError(new Error('error'));
//       return null;
//     }
//     // const resp = await request('estimate-jing-claim-request', {
//     //   body: {
//     //     email,
//     //     policyId,
//     //   },
//     // });
//     console.log('estimate-jing-claim-request', { email, policyId });
//     const resp = MOCK_ESTIMATE_RESP;
//     if (!resp) {
//       logError(new Error(`${TAG} getPackage no resp`));
//       return null;
//     }
//     return resp;
//   } catch (error) {
//     logError(error);
//     return null;
//   }
// };

export const getRAReason = async (policyId) => {
  try {
    const resp = await request('get-claim-reason', {
      body: {
        policyId,
      },
    });
    return resp;
  } catch (err) {
    logError(err);
    return null;
  }
};
export const getPackage = async (policyId, issueType) => {
  try {
    const resp = await request('get-protected-items', {
      body: {
        policyId, issueType,
      },
    });
    // console.log('get_protected-items入参', policyId);
    // const resp = MOCK_RA_ITEMS;
    if (!resp) {
      logError(new Error('get_protected-items no resp'));
      return null;
    }
    return resp;
  } catch (error) {
    logError(error);
    return null;
  }
};
